export const VITE_PORT: number = import.meta.env.VITE_PORT as number;
export const VITE_ROUTER_BASENAME: string =
  (import.meta.env.VITE_ROUTER_BASENAME as string) || "/home/carros-motor";
export const VITE_ENV: string =
  (import.meta.env.VITE_ENV as string) || "development";
export const VITE_BASE_URL: string =
  import.meta.env.VITE_BASE_URL || "https://dpx.iberia.es";
export const VITE_USER_ADMIN: boolean =
  (import.meta.env.VITE_USER_ADMIN &&
    import.meta.env.VITE_USER_ADMIN === "true") ||
  false;
export const VITE_GRAPHQL_URL =
  import.meta.env.VITE_GRAPHQL_URL || "https://dpx.iberia.es:3000/graphql";
